export interface ScreenPoint { x: number; y: number }

export interface ViewportRect { left: number; top: number; right: number; bottom: number }

interface Options {
  /** Width of a panel floating over the map's right edge, if any. */
  rightInset?: number;
  /** How far from an edge a point must be to count as comfortably visible. */
  margin?: number;
}

/**
 * Whether a pin is already on screen and clear of the edges — and of the routes
 * panel, which covers the map's right side without changing its bounds.
 *
 * Selecting a stop only moves the camera when this is false. Recentring on a pin
 * the user can already see is disorienting: the map jumps and everything else
 * they were comparing it against slides away.
 */
export function isPinComfortablyVisible(
  point: ScreenPoint,
  rect: ViewportRect,
  { rightInset = 0, margin = 48 }: Options = {},
): boolean {
  const usableRight = rect.right - rightInset;
  // A panel wider than the map leaves nothing usable; treat the pin as hidden
  // rather than reporting every pin visible against an inverted box.
  if (usableRight - rect.left <= margin * 2) return false;

  return point.x >= rect.left + margin
    && point.x <= usableRight - margin
    && point.y >= rect.top + margin
    && point.y <= rect.bottom - margin;
}
